<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      AI-суммаризация отзывов
    </template>

    <p>Этот текст был сгенерирован искусственным интеллектом на&nbsp;основе отзывов о&nbsp;товаре.</p>

    <template #action>
      <BasicButton color="green" title="Понятно" @click="close" />
    </template>
  </CustomModalWindow>
</template>
